var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Optional } from '@angular/core';
import { concat, remove, some } from 'lodash';
import { DynamicFormClassifiersService } from './dynamic-form-classifiers.service';
import { DynamicFormPopupsService } from './dynamic-form-popups.service';
import { DynamicFormMainDeService } from './dynamic-form-main-de.service';
import { DynamicFormDocumentsService } from './dynamic-form-documents.service';
import { DynamicFormNavigationsService } from './dynamic-form-navigations.service';
import { DynamicFormUtilitiesService } from './dynamic-form-utilities.service';
import { AdditionalActionsProvider } from '../api';
import { DynamicFormWorkflowService } from './dynamic-form-workflow.service';
import { DynamicFormKbService } from './dynamic-form-kb.service';
var ActionResolverService = /** @class */ (function () {
    function ActionResolverService(dynamicFormClassifiersService, dynamicFormPopupsService, dynamicFormMainDeService, dynamicFormDocumentsService, dynamicFormNavigationService, dynamicFormUtilitiesService, dynamicFormWorkflowService, dynamicFormKbService, additionalActionsProvider) {
        this.dynamicFormClassifiersService = dynamicFormClassifiersService;
        this.dynamicFormPopupsService = dynamicFormPopupsService;
        this.dynamicFormMainDeService = dynamicFormMainDeService;
        this.dynamicFormDocumentsService = dynamicFormDocumentsService;
        this.dynamicFormNavigationService = dynamicFormNavigationService;
        this.dynamicFormUtilitiesService = dynamicFormUtilitiesService;
        this.dynamicFormWorkflowService = dynamicFormWorkflowService;
        this.dynamicFormKbService = dynamicFormKbService;
        this.additionalActionsProvider = additionalActionsProvider;
    }
    ActionResolverService.prototype.getAction = function () {
        var result = [];
        result = concat(result, this.dynamicFormClassifiersService.getActions(), this.dynamicFormPopupsService.getActions(), this.dynamicFormDocumentsService.getActions(), this.dynamicFormMainDeService.getActions(), this.dynamicFormNavigationService.getActions(), this.dynamicFormUtilitiesService.getActions(), this.dynamicFormWorkflowService.getActions(), this.dynamicFormKbService.getActions());
        if (this.additionalActionsProvider) {
            var additionalActions_1 = this.additionalActionsProvider.getActions();
            remove(result, function (action) {
                // overwrites
                return some(additionalActions_1, function (value) { return value.name === action.name; });
            });
            result = concat(result, additionalActions_1);
        }
        return result;
    };
    ActionResolverService = __decorate([
        Injectable(),
        __param(8, Optional()),
        __metadata("design:paramtypes", [DynamicFormClassifiersService,
            DynamicFormPopupsService,
            DynamicFormMainDeService,
            DynamicFormDocumentsService,
            DynamicFormNavigationsService,
            DynamicFormUtilitiesService,
            DynamicFormWorkflowService,
            DynamicFormKbService,
            AdditionalActionsProvider])
    ], ActionResolverService);
    return ActionResolverService;
}());
export { ActionResolverService };
//# sourceMappingURL=action-resolver.service.js.map